module.exports = __webpack_public_path__ + "static/media/rightbg.b32ec704.png";